export const GLOBAL_ICONS = ['usa-flag', 'canada-flag'];
